import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ApiService} from './api.service';

import {CrudUtilities} from '../util/crud-utilities';
import {map} from 'rxjs/operators';
import {GalleriesModel} from '../models/galleriesModel';
import {GalleryModel} from '../models/galleryModel';

@Injectable()
export class GalleriesService {


  public galleriesSubject = new BehaviorSubject<GalleriesModel>(new GalleriesModel());
  public galleries = this.galleriesSubject.asObservable();

  public selectedGallerySubject = new BehaviorSubject<GalleryModel>(new GalleryModel());
  public selectedGallery = this.selectedGallerySubject.asObservable();


  constructor(private apiService: ApiService, public crudUtils: CrudUtilities) {

  }

  setGalleryList(galleries: GalleriesModel) {
    this.galleriesSubject.next(galleries);
  }

  createGallery(reference: GalleryModel) {
    return this.apiService.post('galleries.json', reference).subscribe((response) => {

      if (response.name) {
        reference.id = response.name;
        this.selectedGallerySubject.next({...reference});
        this.crudUtils.addNewItemToList(this.galleriesSubject, reference);
      }
    });
  }

  editGallery(reference: GalleryModel) {
    return this.apiService
      .patch(`galleries/${reference.id}.json`, reference).subscribe((response) => {
        this.selectedGallerySubject.next({...response});
        this.crudUtils.editListItem(this.galleriesSubject, response);
      });
  }

  deleteGallery(reference, dialogRef) {
    return this.apiService.delete(`galleries/${reference.id}.json`).subscribe(() => {
      this.crudUtils.deleteListItem(this.galleriesSubject, reference);
      dialogRef.close();

    });
  }

  getGallerys() {
    return this.apiService.get('galleries.json').pipe(map((response) => {

      let list = [];
      for (let key in response) {
        response[key].id = key;
        list.push(response[key]);
      }
      return list;
    }));
  }

  getGallery(id): Observable<any> {
    return this.apiService.get(`galleries/${id}.json`);
  }


}
